<template>
  <v-layout
    row
    wrap
    class="pa-4"
  >
    <v-flex
      id="checkinFields"
      xs12
    >
      <v-form ref="checkinFields">
        <draggable
          v-model="checkinFields"
          handle=".drag-handler"
          :move="checkMove"
        >
          <div
            v-for="(field, index) in checkinFields"
            id="checkInFlowContainer"
            :key="field.id"
          >
            <template v-if="field.type === 'text_field'">
              <v-layout
                row
                wrap
                align-center
              >
                <v-text-field
                  :value="field.label"
                  :disabled="shouldDisable(field)"
                  :rules="[ v => !!v || 'Label is required']"
                  :validate-on-blur="true"
                  style="width:300px"
                  class="pr-2"
                  label="Label"
                  @input="updateLabel($event, field)"
                />
                <v-text-field
                  :value="getFieldTypeText(field.type)"
                  style="width:100px"
                  label="Field Type"
                  class="pr-2"
                  disabled
                />
                <v-select
                  v-model="field.input_type"
                  :items="inputTypes"
                  :disabled="shouldDisable(field)"
                  style="width:80px"
                  item-text="value"
                  item-value="key"
                  label="Input Type"
                  @change="updateType($event, field)"
                />
                <Toggle
                  v-model="field.required"
                  :disabled="shouldDisablePTB(field)"
                  label="Required"
                  class="px-4"
                  @change="updateRequiredTB($event, field)"
                />
                <Toggle
                  v-model="field.hide"
                  :disabled="shouldDisablePTB(field)"
                  label="Hide"
                  @change="updateHideTB($event, field)"
                />
                <template v-if="!shouldDisable(field)">
                  <div class="mb-3">
                    <v-tooltip
                      :open-delay="1500"
                      bottom
                    >
                      <v-btn
                        slot="activator"
                        icon
                        flat
                        @click="deleteField(index)"
                      >
                        <v-icon color="iconColor">
                          delete
                        </v-icon>
                      </v-btn>
                      <span>Delete</span>
                    </v-tooltip>
                    <v-tooltip
                      :open-delay="1500"
                      bottom
                    >
                      <v-btn
                        slot="activator"
                        icon
                        class="drag-handler"
                        flat
                      >
                        <v-icon color="iconColor">
                          format_line_spacing
                        </v-icon>
                      </v-btn>
                      <span>Move</span>
                    </v-tooltip>
                  </div>
                </template>
                <template v-else>
                  <span class="px-5 mr-2" />
                </template>
              </v-layout>
            </template>
            <template v-else>
              <v-layout
                row
                wrap
                align-center
              >
                <v-text-field
                  :value="field.label"
                  :disabled="shouldDisable(field)"
                  :rules="[ v => !!v || 'Label is required']"
                  :validate-on-blur="true"
                  class="pr-2"
                  style="width:300px"
                  label="Label"
                  @input="updateLabel($event, field)"
                />
                <v-text-field
                  :value="getFieldTypeText(field.type)"
                  class="pr-2"
                  style="width:100px"
                  label="Field Type"
                  disabled
                />
                <v-layout
                  row
                  wrap
                  justify-space-between
                  align-center
                  style="width:80px; cursor:pointer"
                  @click.stop="optionToggle(index)"
                >
                  <span class="subheading">
                    Options
                  </span>
                  <v-icon
                    :id="'icon_' + index"
                    color="iconColor"
                  >
                    expand_more
                  </v-icon>
                </v-layout>
                <Toggle
                  v-model="field.required"
                  :disabled="shouldDisablePTB(field)"
                  label="Required"
                  class="px-4"
                  @change="updateRequiredTB($event, field)"
                />
                <Toggle
                  v-model="field.hide"
                  :disabled="shouldDisablePTB(field)"
                  label="Hide"
                  @change="updateHideTB($event, field)"
                />
                <v-tooltip
                  :open-delay="1500"
                  bottom
                >
                  <v-btn
                    slot="activator"
                    icon
                    flat
                    @click="deleteField(index)"
                  >
                    <v-icon color="iconColor">
                      delete
                    </v-icon>
                  </v-btn>
                  <span>Delete</span>
                </v-tooltip>
                <v-tooltip
                  :open-delay="1500"
                  bottom
                >
                  <v-btn
                    slot="activator"
                    icon
                    flat
                    class="drag-handler"
                  >
                    <v-icon color="iconColor">
                      format_line_spacing
                    </v-icon>
                  </v-btn>
                  <span>Move</span>
                </v-tooltip>
              </v-layout>
              <div
                :id="'ic_' + index"
                style="display:none"
              >
                <draggable
                  v-model="field.options"
                  handle=".option-drag-handler"
                >
                  <div
                    v-for="(option, index) in field.options"
                    :key="option.index"
                  >
                    <v-layout
                      row
                      wrap
                      style="width:350px"
                      class="pl-5"
                    >
                      <span class="subheading pt-3 pr-3">
                        {{ getDisplayIndex(index) }}.
                      </span>
                      <v-text-field
                        :ref="'ip'+index"
                        :value="option.value"
                        :validate-on-blur="true"
                        :rules="[
                          (v) => {return validateOption(v, field);}
                        ]"
                        placeholder="Option Name"
                        @input="updateOption($event, field, index)"
                      />
                      <v-tooltip
                        :open-delay="1500"
                        bottom
                      >
                        <v-btn
                          slot="activator"
                          :disabled="shouldDisableDeleteOption(field)"
                          icon
                          @click="deleteOption(field, index)"
                        >
                          <v-icon color="iconColor">
                            delete
                          </v-icon>
                        </v-btn>
                        <span>Delete</span>
                      </v-tooltip>
                      <v-tooltip
                        :open-delay="1500"
                        bottom
                      >
                        <v-btn
                          slot="activator"
                          icon
                          flat
                          class="option-drag-handler"
                        >
                          <v-icon color="iconColor">
                            format_line_spacing
                          </v-icon>
                        </v-btn>
                        <span>Move</span>
                      </v-tooltip>
                    </v-layout>
                  </div>
                </draggable>
                <v-btn
                  color="primary"
                  flat
                  class="ml-5"
                  @click="addNewOption(field)"
                >
                  Add New Option
                </v-btn>
              </div>
            </template>
          </div>
        </draggable>
      </v-form>
      <v-layout
        column
        align-center
        class="pt-2"
      >
        <v-layout
          row
          wrap
          style="width:300px"
          align-center
        >
          <v-select
            v-model="selectedFieldType"
            :items="fieldTypes"
            style="width:120px"
            item-text="value"
            item-value="key"
            label="Field Type"
          />
          <v-btn
            color="primary"
            @click="addNewField"
          >
            Add New Field
          </v-btn>
        </v-layout>
      </v-layout>
    </v-flex>
  </v-layout>
</template>
<script>
import _cloneDeep from 'lodash/cloneDeep';

import Toggle from '@/components/common/Toggle';
import { generateFieldID } from '@/utils';
import draggable from 'vuedraggable';

export default {
  name: 'CheckinFields',
  components: {
    Toggle,
    draggable
  },
  props: {
    data: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      checkinFields: [],
      inputTypes: [
        {
          key: 'text',
          value: 'Text'
        },
        {
          key: 'email',
          value: 'Email'
        },
        {
          key: 'phone',
          value: 'Phone'
        },
        {
          key: 'number',
          value: 'Number'
        }
      ],
      fieldTypes: [
        {
          key: 'text_field',
          value: 'Text Field'
        },
        {
          key: 'single_choice',
          value: 'Single Choice'
        },
        {
          key: 'multi_choice',
          value: 'Multi Choice'
        },
        {
          key: 'dropdown',
          value: 'Dropdown'
        }
      ],
      selectedFieldType: 'text_field'
    };
  },
  watch: {
    data: {
      handler(val) {
        if (!val) return;
        this.checkinFields = _cloneDeep(val);
      },
      immediate: true
    }
  },
  deactivated() {
    const validation = this.$refs.checkinFields.validate();
    let { checkinFields } = this;
    const validatedCheckinFields = [];
    checkinFields.forEach(field => {
      if (!field.label && !validation) return;
      let notEmpty = true;
      if (field.options) {
        field.options.forEach(option => {
          if (!option.value) notEmpty = false;
        });
      }
      if (notEmpty) validatedCheckinFields.push(field);
    });
    checkinFields = validatedCheckinFields;
    this.$emit('update', [checkinFields, validation]);
  },
  methods: {
    checkMove(event) {
      const { id } = event.relatedContext.element;
      if (id === 'email' || id === 'full_name' || id === 'company') {
        return false;
      }
      return true;
    },
    shouldDisable(field) {
      return /^full_name|email|company$/g.test(field.id);
    },

    getFieldTypeText(type) {
      return this.capitalizeFirstLetter(type.replace('_', ' '));
    },

    capitalizeFirstLetter(phrase) {
      return phrase
        .toLowerCase()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    },

    shouldDisablePTB(field) {
      return /^full_name$/g.test(field.id);
    },

    deleteField(index) {
      this.checkinFields.splice(index, 1);
    },

    shouldDisableDeleteOption(field) {
      return field.options.length < 3;
    },

    getDisplayIndex(index) {
      return index + 1;
    },

    updateLabel(value, field) {
      // eslint-disable-next-line
      field.label = value;
    },

    updateType(value, field) {
      // eslint-disable-next-line
      field.input_type = value;
    },

    updateRequiredTB(value, field) {
      // eslint-disable-next-line
      field.required = value;
    },

    updateHideTB(value, field) {
      // eslint-disable-next-line
      field.hide = value;
    },

    optionToggle(index) {
      const ic = document.getElementById(`ic_${index}`);
      const icon = document.getElementById(`icon_${index}`);
      if (ic.style.display === 'block') {
        ic.style.display = 'none';
        icon.innerHTML = 'expand_more';
      } else {
        ic.style.display = 'block';
        icon.innerHTML = 'expand_less';
      }
    },

    addNewOption(field) {
      const newOption = {
        value: ''
      };
      field.options.push(newOption);
    },

    updateOption(value, field, index) {
      // sanitization
      const sanValue = value.replace(',', ' ');
      // eslint-disable-next-line
      field.options[index].value = sanValue;
    },

    validateOption(val, field) {
      const notduplicate =
        field.options.findIndex(option => option.value === val) < 0;
      if (!val) return 'Option is required';
      if (val || notduplicate) return true;
      return 'Duplicate option';
    },

    deleteOption(field, index) {
      field.options.splice(index, 1);
    },

    addNewField() {
      const fid = generateFieldID();
      const field = {
        id: fid,
        label: '',
        required: false,
        hide: false,
        type: this.selectedFieldType
      };

      if (this.selectedFieldType === 'text_field') {
        field.input_type = 'text';
      } else {
        field.options = [
          {
            value: ''
          },
          {
            value: ''
          }
        ];
      }
      this.checkinFields.push(field);
      if (field.type !== 'text_field') {
        const index = this.checkinFields.length - 1;
        this.$nextTick().then(() => {
          const ic = document.getElementById(`ic_${index}`);
          const icon = document.getElementById(`icon_${index}`);
          ic.style.display = 'block';
          icon.innerHTML = 'expand_less';
        });
      }
    }
  }
};
</script>
<style>
#checkinFields {
  height: calc(100vh - 240px) !important;
  overflow-y: auto !important;
}
</style>

